//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseImage from '@/components/common/BaseImage.vue';
import parseYoutubeLinkToId from '@/utils/parseYoutubeLinkToId';

export default {
  components: {
    BaseImage,
  },
  props: {
    imageConfig: {
      type: Array,
      default: () => [
        { ext: 'webp', sizes: ['768x432 1x', '1536x864 2x'] },
        { ext: 'png', sizes: ['768x432 1x', '1536x864 2x'] },
      ],
    },
  },
  computed: {
    event() {
      return this.$store.state.event.data;
    },
    topic() {
      return this.$store.state.event.topic;
    },
    broadcastId() {
      return this.topic.youtubeBroadcast?.broadcastId;
    },
    // Локаль нужна, чтобы указать её в ютуб плеере
    // иначе он будет работать на языке браузера
    currentLocaleName() {
      return this.$app?.config?.current?.localeName;
    },
    src() {
      const youtubeurl = 'https://www.youtube.com/embed/';
      const parsedYoutubeId = this.getParsedYoutubeId();
      const id = parsedYoutubeId || this.broadcastId;
      if (!id) return null;
      return `${youtubeurl}${id}?autoplay=1&rel=0&modestbranding=1&hl=${this.currentLocaleName}&fs=1`;
    },
    displayMobileView() {
      return this.$store.state.event.displayMobileView;
    },
  },
  methods: {
    getParsedYoutubeId() {
      let parsedYoutubeId = null;
      const webinarRecording = this.topic.webinarRecording;
      if (webinarRecording) {
        parsedYoutubeId = parseYoutubeLinkToId(webinarRecording);
      }
      return parsedYoutubeId;
    },
  },
};
